const CenteredTitle = ({ title, subtitle }) => {
  return (
      <div className="text-center max-w-2xl mb-2 md:mb-12">
          <h1 className="text-4xl md:text-7xl font-semi-bold text-gray-900 mb-3">{title}</h1>
          {subtitle && (<p className="text-gray-500 text-lg md:text-2xl font-light">{subtitle}</p>)}
      </div>
  )
}

export default CenteredTitle;